import React from "react";

import * as S from "./styles";

type AmountFieldPropType = {
  children?: React.ReactNode;
  extraMargin?: boolean;
  small?: boolean;
};

const AmountField = ({
  children,
  extraMargin = false,
  small
}: AmountFieldPropType) => (
  <S.Total $extraMargin={extraMargin} $small={small}>
    {children}
  </S.Total>
);

export default AmountField;
